import smallLogo from "../../assets/thrifit-logo-small.png";
import { Link } from "react-router-dom";

const BecomeASeller = ({ data }) => {
  const { text, btnText, href } = data;
  return (
    <div>
      <div className="fixed z-10 w-full bottom-3 -left-5 md:-left-16 flex justify-end">
        <div className="bg-black flex items-center rounded-lg pl-2 pr-2 gap-3 h-13 w-fit">
          <img src={smallLogo} alt="logo" className="w-8 h-5" />
          <p className="text-xs font-medium text-white">{text}</p>
          <Link to={href}>
            <button className="font-medium text-xs  bg-logoRed w-14 h-6 rounded-lg text-white">
              {btnText}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BecomeASeller;
